"use strict";

import jQuery from 'jquery';

/**
 * Control zur Anzeige von Urheberinformationen von Layern.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCAttribution = function( options )
{
	gc.gis.control.GCAbstractMapControl.call(this, options);

	this.DEFAULT_LAYER_COPYRIGHT = '<em>Keine Urheberrechte angegeben</em>';
};
gc.gis.control.GCAttribution.prototype = Object.create( gc.gis.control.GCAbstractMapControl.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.GCAttribution.prototype.init = function()
{
	// Rendern
	this._render();
	this.updateList();

	const self = this;
	const onLayerAdded = function (layers) {
		for (let i = 0; i < layers.length; i++)
		{
			layers[i].on(gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, self, function(evt) {
				self.updateList();
			});
		}
		self.updateList();
	}
	const onLayerRemoved = function (layers) {
		for (let i = 0; i < layers.length; i++)
		{
			layers[i].un(gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, self);
		}
		self.updateList();
	}

	this._map.on(gc.gis.map.GCMapEvent.LAYER_ADDED, this, function(evt) {
		onLayerAdded(evt.layers || []);
	});
	this._map.on(gc.gis.map.GCMapEvent.LAYER_REMOVED, this, function(evt) {
		onLayerRemoved(evt.layers || [])
	});
	this._map.on(gc.gis.map.GCMapEvent.BACKGROUND_LAYER_ADDED, this, function(evt) {
		onLayerAdded(evt.layers || []);
	});
	this._map.on(gc.gis.map.GCMapEvent.BACKGROUND_LAYER_REMOVED, this, function(evt) {
		onLayerRemoved(evt.layers || [])
	});
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.GCAttribution.prototype._render = function()
{
	const self = this;

	if( !this._element )
	{
		this._element = jQuery('<div>', {
			'class': 'gc-map-control gc-map-control-attribution' +(this._className ? ' '+this._className : '')
		});
		this.__element_button = jQuery('<button>', {
			'class': 'gc-attribution-button-toggle gc-button',
			html: '<span class="hidden">Urheberinformationen ein-/ausblenden</span>',
			title: 'Urheberinformationen ein-/ausblenden'
		});
		this.__element_button.prepend( jQuery('<span>', {
			'class': 'gc-icon glyphicon glyphicon-copyright-mark'
		}) );
		this.__element_button.on('click', function( evt ) {
			if( self.__element_list.is(':visible') || self.__element_list.children().length === 0 )
			{
				self.__element_list.hide('blind', {
					direction: 'down',
					complete: function( evt ) {	// FIXME: duplicate name 'evt' <- effect=?
						self._element.removeClass('gc-expanded').addClass('gc-collapsed');
						self.__element_button.removeClass('gc-active');
					}
				});
			}
			else
			{
				self.__element_list.show('blind', {
					direction: 'down',
					complete: function( evt ) {
						self.__element_button.addClass('gc-active');
					}
				});
				self._element.removeClass('gc-collapsed').addClass('gc-expanded');
			}
			self.__element_button.blur();
		});
		gc.gis.iface.ui.tooltip(this.__element_button, {
			placement: 'auto top'
		});

		this.__element_list = jQuery('<ul>', {
			'class': 'gc-attribution-list'
		});
		this.__element_list.hide();
		this._element.append( this.__element_button );
		this._element.append( this.__element_list );
	}
	return this._element;
};

/**
 * Aktualisiert die Layerliste.
 *
 * @public
 */
gc.gis.control.GCAttribution.prototype.updateList = function()
{
	const layers = this._getRelevantLayers();

	this.__element_list.children().remove();
	if(layers.length > 0)
	{
		const attributions = {};
		for (let i = 0; i < layers.length; i++)
		{
			let key = this._getAttributionForLayer(layers[i]);
			if (!attributions[key])
			{
				attributions[key] = [];
			}
			attributions[key].push(layers[i]);
		}

		let keys = Object.keys(attributions);
		for (let i = 0; i < keys.length; i++)
		{
			this.__element_list.append(
				this._renderListItem(keys[i], attributions[keys[i]])
			);
		}

		this._element.show();
	}
	else
	{
		this._element.hide();
	}
};

/**
 * @param {gc.gis.layer.GCLayer} layer
 * @return {string}
 * @private
 */
gc.gis.control.GCAttribution.prototype._getAttributionForLayer = function(layer)
{
	let attribution = layer.getAttribution() || '';
	attribution = gc.gis.GCUtil.stripTags(attribution);
	attribution = attribution || this.DEFAULT_LAYER_COPYRIGHT;

	return attribution;
};

/**
 * @public
 */
gc.gis.control.GCAttribution.prototype._getRelevantLayers = function()
{
	const layers = this._map.getRoot().getLayersRecursive(function(layer) {
		return (layer instanceof gc.gis.layer.GCLayer && layer.isReallyVisible() );
	});

	const bgLayer = this._map.getVisibleBackgroundLayer();
	if (bgLayer)
	{
		layers.unshift(bgLayer);
	}

	return layers;
};

/**
 * Rendert einen Urheberrechtseintrag.
 *
 * @protected
 * @param {string} key Urheberrechtstext
 * @param {gc.gis.layer.GCAbstractLayer[]} layers Liste von Layern mit gleichem
 *   Urheberrechtstext
 * @return {jQuery} jQuery-Listenelement
 */
gc.gis.control.GCAttribution.prototype._renderListItem = function(key, layers)
{
	const element_label = jQuery('<strong>', {
		'class': 'gc-attribution-label',
		html: '<span class="gc-attribution-label-text">'+ key +'</span>'
	});
	element_label.prepend( jQuery('<span>', {
		'class': 'gc-icon glyphicon'
	}) );
	const element = jQuery('<li>', {
		'class': 'gc-collapsed',	// start collapsed
		html: element_label
	});

	const element_list = jQuery('<ul>', {
		'class': 'gc-attribution-layers'
	});
	for (let i = 0; i < layers.length; i++)
	{
		element_list.append(jQuery('<li>', {
			html: layers[i].getLabel()
		}) );
	}
	element_list.hide();	// start collapsed
	element.append(element_list);

	element_label.on('click', function() {
		if (element_list.is(':visible') )
		{
			element_list.hide('blind', {
                //direction: 'up',
				complete: function( evt ) {
					element.removeClass('gc-expanded').addClass('gc-collapsed');
				}
			});
		}
		else
		{
			element_list.show('blind', {
                //direction: 'up'
            });
			element.removeClass('gc-collapsed').addClass('gc-expanded');
		}
	});

	return element;
};

